<template lang='pug'>
#section1
	#section1-anchor
	.video-section
		img.pattern(src='@/assets/waves1.svg')
		video(controls poster='@/assets/video_poster.jpg')
			source(src='/video.mp4' type='video/mp4')
	.content-section
		.header
			h2 Brot af því besta
			img.underline(src='@/assets/blue_wave.svg')
		.paragraph
			p Skínandi hamingja og gleði einkennir mótið eins og sjá má á myndbandinu.

</template>

<script>
export default {
	name: 'Section1',
	methods: {
		changeNav: function (target) {
			this.$SmoothScroll(document.getElementById(target), 700, null, null, 'y');
			this.nav = false;
		}
	}
};
</script>

<style lang="less" scoped>
#section1 {
	#section1-anchor {
		width: 100vw;
		height: 5px;
		position: absolute;
		top: -100px;
	}
	position: relative;
	transform: translateY(-150px);
	display: grid;
	grid-template-columns: 1fr 1fr;
	@media screen and (max-width: 1439px) {
		grid-template-columns: 1fr;
	}
	.content-section {
		@media screen and (max-width: 1439px) {
			position: relative;
			top: 50px;
			margin-left: auto;
			margin-right: auto;
		}
		@media screen and (max-width: 475px) {
			padding-left: 30px;
			padding-right: 30px;
		}
		.header {
			h2 {
				font-size: 40px;
				color: #f3736b;
				font-weight: bold;
				@media screen and (max-width: 870px) {
					font-size: 31px;
				}
			}
			.underline {
				transform: translateY(-20px);
			}
		}
		.paragraph {
			p {
				transform: translateY(-10px);
				margin-top: 0px;
				max-width: 426px;
				line-height: 1.94;
				font-size: 18px;
				margin-left: 78px;
				@media screen and (max-width: 530px) {
					margin-left: 0px;
					font-size: 16px;
				}
			}
		}
		.button {
			margin-left: 78px;
			width: 158px;
			height: 48px;
			border-radius: 24px;
			border: solid 2px #118acd;
			line-height: 48px;
			text-align: center;
			font-size: 21px;
			font-weight: bold;
			transition: .5s;
			cursor: pointer;
			background: url('~@/assets/top.svg');
			background-size: 177px 101px;
			background-position-y: -100px;
			background-repeat: no-repeat;
			&:hover {
				color: white;
				background-position-y: 0px;
			}
			@media screen and (max-width: 530px) {
				margin-left: auto;
				margin-right: auto;
			}
		}
	}
	.video-section {
		video {
			position: absolute;
			width: 575px;
			height: 323px;
			left: 117px;
			top: 96px;
		}
		@media screen and (max-width: 1439px) {
			.pattern {
				position: absolute;
			}
			video {
				position: relative;
				width: 575px;
				height: 323px;
				left: 50%;
				transform: translateX(-50%);
				top: 46px;
			}
		}
		@media screen and (max-width: 640px) {
			video {

				width: 100%;
				height: auto;
			}
		}
	}
}
</style>
